import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g transform="translate(5.7778 5)" stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <circle cx="6.2222" cy="4" r="4" />
      <path d="M6.2222 8c3.3137 0 6 2.6863 6 6h-12c0-3.3137 2.6863-6 6-6Z" />
    </g>
  </svg>
);
